import { Box } from "@mui/material";

const PanelTab = ({ value, index, children }) => {
  return (
    <Box hidden={value !== index} mt={2} maxWidth={"98%"}>
      {children}
    </Box>
  );
};

export default PanelTab;
